<div class="fm">
  <button
    class="fm-button"
    type="button"
    [class.open]="isOpen()"
    [attr.aria-expanded]="isOpen()"
    aria-haspopup="dialog"
    (click)="toggle()"
  >
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
      stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
    Filters
  </button>

  <!-- Applied filters: click to change, × to remove. -->
  @for (chip of appliedChips(); track chip.field.key) {
    <span class="fm-chip">
      <button
        class="fm-chip-edit"
        type="button"
        [attr.aria-label]="'Change the ' + chip.field.label + ' filter'"
        (click)="editChip(chip.field)"
      >
        <span class="fm-chip-key">{{ chip.field.label }}:</span>
        <span class="fm-chip-value">{{ chip.valueLabel }}</span>
      </button>
      <button
        class="fm-chip-remove"
        type="button"
        [attr.aria-label]="'Remove the ' + chip.field.label + ' filter'"
        (click)="remove(chip.field)"
      >
        ×
      </button>
    </span>
  }
</div>

@if (isOpen()) {
  <div class="fm-backdrop" (click)="close()"></div>
  <div
    class="fm-panel"
    role="dialog"
    aria-label="Filters"
    [style.top.px]="panelPosition()?.top"
    [style.left.px]="panelPosition()?.left"
  >
    @if (editingField(); as field) {
      <!-- Step two: how the chosen filter applies. -->
      <div class="fm-panel-head">
        <button class="fm-back" type="button" aria-label="Back to filters" (click)="backToFields()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
            stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <span class="fm-panel-title">{{ field.label }}</span>
      </div>

      <div class="fm-panel-body">
        @if (field.kind === 'select') {
          <select
            #optionSelect
            class="fm-select"
            [attr.aria-label]="field.label"
            [value]="draftValue()"
            (change)="draftValue.set(optionSelect.value)"
          >
            <option value="">Choose…</option>
            @for (option of field.options; track option.value) {
              <option [value]="option.value" [selected]="option.value === draftValue()">{{ option.label }}</option>
            }
          </select>
        } @else {
          <label class="fm-date-row">
            <span class="fm-date-label">From</span>
            <input
              #fromInput
              class="fm-date"
              type="date"
              [attr.aria-label]="field.label + ' from'"
              [value]="draftFrom()"
              [max]="draftTo()"
              (change)="draftFrom.set(fromInput.value)"
            />
          </label>
          <label class="fm-date-row">
            <span class="fm-date-label">To</span>
            <input
              #toInput
              class="fm-date"
              type="date"
              [attr.aria-label]="field.label + ' to'"
              [value]="draftTo()"
              [min]="draftFrom()"
              (change)="draftTo.set(toInput.value)"
            />
          </label>
        }
      </div>

      <div class="fm-panel-foot">
        <button class="fm-apply" type="button" [disabled]="!canApply()" (click)="apply()">Apply</button>
      </div>
    } @else {
      <!-- Step one: which filter. -->
      <div class="fm-fields">
        @for (field of fields(); track field.key) {
          <button class="fm-field" type="button" (click)="editField(field)">
            {{ field.label }}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
              stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        }
      </div>
    }
  </div>
}
